import { useState } from "react";
import { suggestTopic } from "../api.js";
import { gw } from "../gateway.js";
import AuthSheet from "../screens/AuthSheet.jsx";

const MAX = 200;

/**
 * 「이런 거 다뤄주세요」.
 *
 * ★ 낸 글이 그대로 주제가 되지는 않는다. 그걸 숨기지 않는다 —
 * 「당신 주제를 올려드려요」라고 해놓고 안 올라가면 그게 더 나쁘다.
 * 재료로 쓰인다고 정확히 말하고, 대신 매주 반영된다는 것도 말한다.
 */
export default function SuggestTopic() {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState(null);
  const [sheet, setSheet] = useState(false);

  async function send() {
    setBusy(true);
    setErr(null);
    try {
      const r = await suggestTopic(text.trim());
      setDone(r);
      setText("");
    } catch (e) {
      // 서버 문구가 이미 해요체다. 그대로 띄운다 (매핑 계층을 두지 않는다).
      // SDK 가 메시지 끝에 [401] 같은 코드를 붙인다. 사용자에게 보일 말이 아니다.
      setErr(String(e?.message ?? "지금은 안 되네요. 잠시 뒤에 다시 해주세요.").replace(/\s*\[\d+\]\s*$/, ""));
    } finally {
      setBusy(false);
    }
  }

  /**
   * ★ 익명이면 폼을 열지 않는다.
   * 서버(requireUser)가 어차피 막지만, 다 쓰고 나서 막히면 쓴 게 날아간다 —
   * 「입력이 미달이어도 기존 내용을 버리지 않는다」와 같은 이유다.
   */
  if (gw.isAnonymous()) {
    return (
      <>
        <button type="button" className="btn" style={{ minHeight: 44 }} onClick={() => setSheet(true)}>
          다루고 싶은 게 있어요 <span className="note">· 로그인 필요</span>
        </button>
        {sheet && <AuthSheet mode="login" onClose={() => setSheet(false)} onDone={() => setSheet(false)} />}
      </>
    );
  }

  if (!open) {
    return (
      <button type="button" className="btn" style={{ minHeight: 44 }} onClick={() => setOpen(true)}>
        다루고 싶은 게 있어요
      </button>
    );
  }

  if (done) {
    return (
      <section className="card ai" style={{ borderRadius: 4, gap: 8 }}>
        <h2 className="label">받았어요</h2>
        <p style={{ fontSize: 15, fontWeight: 700, lineHeight: 1.6 }}>
          다음 주 주제를 만들 때 참고할게요.
          {done.left > 0 && ` 오늘 ${done.left}번 더 낼 수 있어요.`}
        </p>
        <button type="button" className="btn" style={{ alignSelf: "flex-start", minHeight: 40 }}
          onClick={() => { setDone(null); setOpen(false); }}>닫기</button>
      </section>
    );
  }

  const left = MAX - text.length;

  return (
    <section className="card" style={{ borderRadius: 4, gap: 10 }}>
      <h2 className="label">다루고 싶은 게 있어요</h2>
      <p className="note" style={{ margin: 0 }}>
        매주 월요일에 새 주제를 만들 때 <strong>참고 자료로</strong> 써요.
        쓰신 문장이 그대로 주제가 되지는 않고, 그대로 공개되지도 않아요.
      </p>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value.slice(0, MAX))}
        rows={3}
        placeholder="요즘 뭐가 애매하세요? 예) 반려동물 의료비가 너무 비싼 거 아닌가"
        style={{
          width: "100%", boxSizing: "border-box", padding: "12px 14px",
          border: "var(--line)", borderRadius: 4, background: "var(--white)",
          fontFamily: "inherit", fontSize: 15, fontWeight: 700, lineHeight: 1.6, resize: "vertical",
        }}
      />
      <span className="note">{left}자 남음 · 정치·선거 주제는 다루지 않아요</span>
      {err && <p className="note" role="alert" style={{ margin: 0 }}>{err}</p>}
      <div style={{ display: "flex", gap: 8 }}>
        <button type="button" className="btn primary" style={{ minHeight: 44, flex: 1 }}
          disabled={busy || text.trim().length < 4} onClick={send}>
          {busy ? "보내는 중…" : "보내기"}
        </button>
        <button type="button" className="btn" style={{ minHeight: 44 }}
          onClick={() => { setOpen(false); setErr(null); }}>닫기</button>
      </div>
    </section>
  );
}
